<script setup lang="ts">
import { MATE_LANE_CODE, THEME_CODE } from '@/enums';
import MateLogoBlack from '@/assets/images/logo-black.svg';
import MateLogoWhite from '@/assets/images/logo-white.svg';
import MateLogoMiniWhite from '@/assets/images/logo_mini_white.svg';
import MateLogoMiniBlack from '@/assets/images/logo_mini_black.svg';
import Cookies from 'js-cookie';
import useGlobalStore from '@/store/globalStore';
import { getEnvironmentFromHostname } from '@/utils';
import { computed } from 'vue';
import EnvironmentTips from '@/components/environment-tips/EnvironmentTips.vue';

const props = defineProps<{
  size: string;
}>();

const currentLane = Cookies.get(MATE_LANE_CODE);
const globalStore = useGlobalStore();

const env = getEnvironmentFromHostname();

const envText = computed(() => {
  return env === 'prod' ? '' : env.toUpperCase();
});

const SIZED_LOGO_MAP = {
  mini: {
    white: MateLogoMiniWhite,
    black: MateLogoMiniBlack,
  },
  medium: {
    white: MateLogoWhite,
    black: MateLogoBlack,
  },
};

const logoSrc = computed(() => {
  const logoMapping =
    props.size === 'mini' ? SIZED_LOGO_MAP.mini : SIZED_LOGO_MAP.medium;
  console.log('globalStore.theme', globalStore.theme);
  console.log('logoMapping.white', logoMapping.white);
  return globalStore.theme === THEME_CODE.cloudyGrey
    ? logoMapping.black
    : logoMapping.white;
});
</script>

<template>
  <div
    :class="{
      'mate-logo': true,
      'mate-logo--mini': props.size === 'mini',
    }"
  >
    <div class="mate-logo__wrapper">
      <img alt="mate-logo" :src="logoSrc" class="mate-logo__logo-img" />
      <div
        :class="{
          'mate-logo__env-badge': true,
          [`mate-logo__env-badge--${env}`]: true,
        }"
      >
        {{ envText }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.mate-logo {
  margin: 16px 8px;
  &__wrapper {
    position: relative;
    margin-top: 2px;
  }
  &__logo-img {
    height: 24px;
    display: block;
  }
  &__env-badge {
    position: absolute;
    bottom: 4px;
    z-index: 1;
    padding: 1px 4px;
    justify-content: center;
    align-items: flex-start;
    border-radius: 10px;
    font-size: 9px;
    font-style: normal;
    font-weight: bold;
    line-height: 10px;
    color: #040b29;
    &--prod {
      display: none;
    }
    &--stg {
      background: #45d9d6;
      right: 0;
      bottom: 4px;
    }
    &--test {
      background: #6fd682;
      right: 0;
      bottom: 4px;
    }
    &--local {
      background: #ff0000;
      right: 0;
      bottom: 4px;
    }
    &--dev {
      background: #b37feb;
      right: 0;
      bottom: 4px;
    }
  }

  &--mini {
    .mate-logo__wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: center;
      flex-direction: column;
    }
    .mate-logo__env-badge {
      position: relative;
      left: 0;
      bottom: 8px;
    }
    .mate-logo__logo-img {
      height: 32px;
    }
    .mate-logo__env-badge {
      bottom: -3px;
      &--prod {
        display: none;
      }
      &--stg {
        background: #45d9d6;
        left: -2px;
      }
      &--test {
        background: #6fd682;
        left: -4px;
      }
      &--local {
        background: #ff0000;
        left: -3px;
      }
      &--dev {
        background: #b37feb;
        left: -3px;
      }
    }
  }
}
</style>
